import { render, staticRenderFns } from "./CustomerHomeComponent.vue?vue&type=template&id=61c99460&"
import script from "./CustomerHomeComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerHomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports